module.exports = __webpack_public_path__ + "media/images/icon-carrot-inverted-554a96b7.png";